/**
 * File header.js.
 */

(function ($) {
	'use strict';

	$(document).ready(function () {

		headerSizeSpace();

		// resize functions calls
		$(window).on('resize', function () {
			headerSizeSpace();
		});

		// return if link is #
		$(document).on('click', 'a[href="#"]', function () {
			return false;
		});

		$('.site-header ul.primary-menu li.menu-item-has-children > a').after('<i class="fa fa-angle-down submenu-toggle" aria-hidden="true"></i>');

		$(document).on('click', '.site-header .menu-toggle', function () {
			$('.site-header').toggleClass('toggled');
			$('body').toggleClass('off-scroll');
		});

		$(document).on('click', '.site-header .site-header__top-action li.search a', function () {
			//$('.site-header .site-header__search-popup').toggle('show');
			$('.site-header .site-header__search-popup').toggleClass('toggled');
			$(this).parent().toggleClass('toggled');
			//$('body').toggleClass('off-scroll');
		});

		// $(document).on('click', function(event) {
		// 	const searchPopup = $('.site-header .site-header__search-popup');
		// 	const searchButton = $('.search');
			
		// 	if (!searchPopup.is(event.target) && searchPopup.has(event.target).length === 0 &&
		// 		!searchButton.is(event.target) && searchButton.has(event.target).length === 0) {
		// 			$('.site-header .site-header__search-popup').removeClass('toggled');
		// 			$('.site-header .site-header__top-action li.search').removeClass('toggled');
		// 			//$('body').removeClass('off-scroll');
		// 	}
		// });

		$(document).on('click', '.site-header ul.primary-menu li .submenu-toggle', function () {
			const windowWidth = $(window).outerWidth();
			if (1200 > windowWidth) {
				$(this).parent('li').toggleClass('active');
				$(this).siblings('.sub-menu, .children').slideToggle();
			}
		});

		$('.site-header ul.primary-menu li').hover(function () {
			const windowWidth = $(window).outerWidth();
			if (1199 < windowWidth && $(this).hasClass('menu-item-has-children')) {
				$(this).toggleClass('active').siblings().removeClass('active');
			}
		});

		$(document).on('click', '.site-header__language-action', function () {
			$('.site-header__languages-list').toggle();
		});

		$(document).on('click', function (e) {
			if (!$(e.target).closest('.site-header__languages-list').length && !$(e.target).closest('.site-header__language-action').length) {
				$('.site-header__languages-list').hide();
			}
		});

		// Sticky Header
		$(window).scroll(function () {
			if ($(window).scrollTop() >= 80) {
				$('.site-header').addClass('fixed-header');
			} else {
				$('.site-header').removeClass('fixed-header');
			}
		});

		// Search keyword from partners submenu.
		$( document ).on( 'click', '.custom-partners-menu-search-btn', function() {
			let _this     = $( this ),
				parentObj = _this.parents( '.custom-partners-menu' ),
				resultObj = parentObj.find( '.custom-sub-menu-wrap' ),
				perPage   = parentObj.attr( 'data-per-page' ) || 8,
				searchVal = parentObj.find( '.custom-partners-menu-search' ).val() || '';

			parentObj.addClass('partner-search-loading');
			jQuery.ajax({
				type: 'POST',
				dataType: "json",
				data: {
					action: "partner_search",
					ajax_nonce: siteConfig.ajax_nonce,
					posts_per_page: perPage,
					search: searchVal
				},
				url: siteConfig.ajaxUrl,
				success: function ( postData ) {
					if (postData.success) {
						let postObj = postData.data.result_post;
						resultObj.html( postObj );
					}
					parentObj.removeClass('partner-search-loading');
				}
			});
		});
	});

	function headerSizeSpace() {
		let header = $('.site-header');
		if (0 < header.length) {
			$('body:not(.has-transparent-header) .site-main').css('padding-top', header.outerHeight());
		}
	}

})(jQuery);
